import { Capacitor, Plugins } from '@capacitor/core'
import { PushNotifications } from '@capacitor/push-notifications'
import { NotificationTokenTypes } from '~/shared/config/enums'
import { logger } from '~/shared/lib/logger'
import { setPushNotificationsData } from './model'

const getFirebaseToken = (): Promise<string | null> => {
  return new Promise((resolve) => {
    PushNotifications.addListener('registration', (token) => {
      resolve(token?.value ?? null)
    })

    PushNotifications.addListener('registrationError', () => {
      resolve(null)
    })
  })
}

const addNotificationListeners = async () => {
  try {
    let tokenType = NotificationTokenTypes.firebase
    let notificationToken = await getFirebaseToken()

    if (!notificationToken) {
      const res = await Plugins.RuStorePush.getToken()

      if (res.token) {
        notificationToken = res.token
        tokenType = NotificationTokenTypes.rustore
      }
    }

    if (notificationToken) {
      setPushNotificationsData({ notificationToken, tokenType })
    }
  } catch (e) {
    logger.error(e)
  }
}

const registerFirebaseNotifications = async () => {
  let permStatus = await PushNotifications.checkPermissions()

  if (permStatus.receive === 'prompt') {
    permStatus = await PushNotifications.requestPermissions()
  }

  if (permStatus.receive !== 'granted') {
    throw new Error('User denied permissions!')
  }

  await PushNotifications.register()
}

export const initPushNotifications = async () => {
  const platform = Capacitor.getPlatform()
  if (platform === 'web') return

  await registerFirebaseNotifications()
  await addNotificationListeners()
}
